import React from 'react';
import { formatDistanceToNowStrict, isValid } from 'date-fns';
import { renderStatus } from '../../utils/tables';
import OverflowText from './overflowText';

const columns = [
  {
    Header: 'Name',
    id: 'displayName',
    accessor: site => <span>{site.displayName || site.id}</span>
  },
  {
    Header: 'Campaigns',
    id: 'campaigns',
    accessor: site => site.campaigns.length ? (
      <div className="pill-group">
        {site.campaigns.map(campaign => (
          <OverflowText key={campaign.id}
            badge
            text={`${campaign.displayName}${campaign.archived ? ' (archived)' : ''}`} />
        ))}
      </div>
    ) : <span className="status badge badge-pill badge-outline-secondary">No campaigns</span>
  },
  {
    Header: 'Status',
    id: 'status',
    accessor: site => ['ENABLED', 'DISABLED', 'NOT_CONFIGURED'].includes(site.status)
      ? renderStatus(site.status === 'NOT_CONFIGURED' ? 'not-configured' : site.status)
      : '--'
  },
  {
    Header: 'Type',
    id: 'type.displayName',
    accessor: site => site.type?.displayName || '--'
  },
  {
    Header: 'Created',
    id: 'createTime',
    accessor: site => site.createTime && isValid(new Date(site.createTime))
      ? <OverflowText text={formatDistanceToNowStrict(new Date(site.createTime), { addSuffix: true })} />
      : '--'
  }
];

export default columns;
